import { useState, useEffect, Fragment } from "react";
import { Input, Select, Button, ToolIcon, List, Flex, Text } from "@theorgchartdev/storybook";
import { CommonSelectProperties } from "./Constants";
import ActionListItem from "@/appComponents/Blocks/Composites/ActionListItem/ActionListItem";
import { appstr } from "@coreapp/utils/appstr";
// Note: this could be moved to the Storybook repo and reused
export const MultiStringInput = ({
  value,
  field,
  options,
  maxValues = -1,
  onUpdate,
  dataTestIdPrefix
}) => {
  const [strings, setStrings] = useState(value); // value must be an array of strings

  useEffect(() => {
    let initialValue = value ?? [];
    if (!Array.isArray(initialValue)) {
      if (initialValue.length > 0) initialValue = [initialValue];
      else initialValue = [];
    } else if (maxValues === 1) {
      if (initialValue.length > 0) initialValue = [initialValue[0]];
      else initialValue = [];
    }
    setStrings(initialValue);
  }, [value]);

  const [addingMode, setAddingMode] = useState(false);
  const [pendingValue, setPendingValue] = useState("");

  let addControls;

  const hasFieldValues = options && options.length > 0;
  const fieldIsSet = field != null && field !== "" && field !== "None";
  if (addingMode) {
    addControls = (
      <Flex width={"100%"} gap={"8px"} alignItems={"center"}>
        <Flex direction={"column"} gap={"8px"} width={"100%"} padding={"0 0 12px 0"}>
          <Text size={"small"} modifier={"bold"}>
            {appstr("New value")}
          </Text>
          <Flex direction={"column"} gap={"12px"} width={"100%"}>
            <Select
              value={0}
              dataTestId={dataTestIdPrefix ? `${dataTestIdPrefix}-value-select` : undefined}
              disabled={!hasFieldValues || !fieldIsSet}
              placeholder={appstr("Choose field value")}
              options={options.map((fv, i) => ({
                label: fv,
                content: fv,
                value: fv,
                clickHandler: () => {
                  const updatedStrings = [...strings, fv];
                  setStrings(updatedStrings);
                  setPendingValue("");
                  setAddingMode(false);
                  onUpdate(updatedStrings);
                }
              }))}
              {...CommonSelectProperties}
            />
            <Text size={"xsmall"} modifier={"medium"}>
              {appstr("OR")}
            </Text>
            <Input
              id={"multi-string-input-add-input"}
              placeholder={appstr("Enter custom value")}
              value={pendingValue}
              disabled={!fieldIsSet}
              onChange={e => setPendingValue(e.target.value)}
              size={"small"}
            />
          </Flex>
        </Flex>
        <ToolIcon
          onClick={() => {
            const updatedStrings = [...strings, pendingValue];
            setStrings(updatedStrings);
            setPendingValue("");
            setAddingMode(false);
            onUpdate(updatedStrings);
          }}
          disabled={maxValues > -1 && strings.length >= maxValues}
          size={"medium-small"}
          name={"check"}
        />
        <ToolIcon
          onClick={() => {
            setAddingMode(false);
            setPendingValue("");
          }}
          size={"medium-small"}
          name={"xmark"}
        />
      </Flex>
    );
  }

  const showAddValueButton = (maxValues > -1 && strings.length < maxValues) || maxValues === -1;
  const hasValuesAdded = strings && Array.isArray(strings) && strings.length > 0;
  return (
    <Flex direction={"column"} gap={"8px"}>
      <Flex direction={"column"} gap={"24px"}>
        {addControls}
        <Flex>
          <Text size={"small"} modifier={"medium"}>
            {maxValues === -1 || maxValues > 1 ? appstr("Values") : appstr("Value")}
          </Text>
          {showAddValueButton && hasValuesAdded && (
            <Flex className={"oc-right-justify"}>
              <Button
                onClick={() => {
                  setAddingMode(true);
                }}
                disabled={maxValues > -1 && strings.length >= maxValues}
                modifier={"secondary"}
                size={"small"}
              >
                {appstr("Add new value")}
              </Button>
            </Flex>
          )}
        </Flex>
      </Flex>
      {hasValuesAdded ? (
        <List
          enableVirtualization={false}
          showCheck={false}
          listWidth="fill"
          value={0}
          optionSize={"small"}
          options={strings.map((s, i) => ({
            value: s,
            content: (
              <ActionListItem
                label={s}
                labelProps={{ size: "small" }}
                actions={[
                  {
                    iconName: "trash-can",
                    iconProps: { color: "error" },
                    onClick: () => {
                      const stringsCopy = [...strings];
                      stringsCopy.splice(i, 1);
                      setStrings(stringsCopy);
                      onUpdate(stringsCopy);
                    }
                  }
                ]}
              />
            )
          }))}
        />
      ) : (
        fieldIsSet &&
        !addingMode && (
          <Button
            onClick={() => {
              setAddingMode(true);
            }}
            disabled={maxValues > -1 && strings.length >= maxValues}
            modifier={"underline"}
            size={"small"}
            dataTestId={dataTestIdPrefix ? `${dataTestIdPrefix}-add-value` : undefined}
          >
            {appstr("No values added. Click here to add a value")}
          </Button>
        )
      )}
    </Flex>
  );
};
